
<footer class="footer">
  <div class="footer--container">
    <div class="footer--content">
      <!-- About Section -->
      <div class="footer--section footer--about">
        <h3 class="footer--title">TANUH</h3>
        <p class="footer--tagline">The AI Centre of Excellence in Healthcare</p>
        <p class="footer--organisation">AI Centre of Excellence in Healthcare</p>
        <address class="footer--address">
          Indian Institute of Science<br />
          Seventh Floor, TCS Smart-X Hub<br />
          Bengaluru, India - 560 012
        </address>

        <div class="footer--contact">
          <div class="contact--item">
            <img [src]="emailIcon" alt="Email" class="contact--icon" />
            <a [href]="contactEmailHref">Email: {{ contactEmail }}</a>
          </div>
          <div class="contact--item contact--item-phone">
            <span
              >Telephone: {{ phonePrimary }} | {{ phoneSecondary }}</span
            >
          </div>
        </div>
      </div>

      <!-- Important Links -->
      <div class="footer--section footer--links">
        <h3 class="footer--section-title">Important links</h3>
        <ul class="footer--link-list">
          <li *ngFor="let link of importantLinks">
            <a 
              *ngIf="!link.external && link.label !== 'Dashboard' && link.url" 
              [routerLink]="link.url" 
              class="footer--link">{{ link.label }}</a>
            <a 
              *ngIf="!link.external && link.label === 'Dashboard'" 
              href="#"
              (click)="onDashboardClick($event)"
              class="footer--link">{{ link.label }}</a>
            <a *ngIf="link.external" [href]="link.url" target="_blank" rel="noopener noreferrer" class="footer--link">{{ link.label }}</a>
          </li>
        </ul>
      </div>

      <!-- Developer Links -->
      <div class="footer--section footer--developers">
        <h3 class="footer--section-title">For Developers</h3>
        <ul class="footer--link-list">
          <li *ngFor="let link of developerLinks">
            <a [href]="link.url" target="_blank" rel="noopener noreferrer" class="footer--link">{{ link.label }}</a>
          </li>
        </ul>
      </div>

      <!-- Social Media -->
      <div class="footer--section footer--social-column">
        <h3 class="footer--section-title">Social Media</h3>
        <ul class="footer--social-list">
          <li *ngFor="let social of socialLinks" class="footer--social-item">
            <a
              [href]="social.url"
              class="footer--social-anchor"
              target="_blank"
              rel="noopener noreferrer"
              [attr.aria-label]="social.label"
            >
              <img [src]="social.iconSrc" alt="" width="24" height="24" class="footer--social-icon" />
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Copyright & legal links -->
    <div class="footer--bottom">
      <p class="footer--copyright">
        <span>© {{ currentYear }} by TANUH</span>
        <span class="footer--legal-sep" aria-hidden="true">|</span>
        <span>Developed by Datakaveri Systems Pvt Ltd</span>
      </p>
      <nav class="footer--legal" aria-label="Legal">
        <a routerLink="/privacy-policy" class="footer--legal-link">Privacy Policy</a>
        <span class="footer--legal-sep" aria-hidden="true">|</span>
        <a routerLink="/terms-of-service" class="footer--legal-link">Terms of Service</a>
      </nav>
    </div>
  </div>
</footer>

